import { render, staticRenderFns } from "./LiquidationSubmissionDetail.vue?vue&type=template&id=1bea2980&scoped=true&lang=pug"
import script from "./LiquidationSubmissionDetail.vue?vue&type=script&lang=js"
export * from "./LiquidationSubmissionDetail.vue?vue&type=script&lang=js"
import style0 from "./LiquidationSubmissionDetail.vue?vue&type=style&index=0&id=1bea2980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea2980",
  null
  
)

export default component.exports